<template>
    <span class="primary-btn" :class="clsName" @click="clickHandler">
        <div v-if="icon" class="round-btn-icon" :style="{background: iconBg}"></div>
        {{text}}
    </span>
</template>

<script>
/**
 * emit btnClick
 */
export default {
    name: "RoundButton",
    props: ["text", "cls", "icon", "addData"],
    methods: {
        clickHandler(event) {
            this.$emit("btnClick", {
                event,
                addData: this.addData
            });
        }
    },
    computed: {
        clsName() {
            return this.cls || "";
        },
        iconBg() {
            return this.icon.indexOf('url') != -1 ? this.icon : 'url(' + this.icon + ')';
        }
    }
};
</script>

<style lang="scss" scoped>
.primary-btn {
    display: inline-block;
    min-width: 96px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    background: #2ec2ff;
    box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
    border-radius: 30px;
    font-size: 14px;
    margin-right: 16px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
        background: rgba(46, 194, 255, 0.8);
    }
}

.round-btn-icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    vertical-align: text-bottom;
}
</style>
